import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { TUrlPath } from "../utils/types/elements/XText.types";

export const USE_X_PATH = atom<TUrlPath>({
  key: "USE_X_PATH",
  default: "/",
});

export function useXPath() {
  const [xPath, setXPath] = useRecoilState(USE_X_PATH);

  return { xPath, setXPath };
}

export function useXPathUpdater() {
  return useSetRecoilState(USE_X_PATH);
}

export function useXPathValue() {
  return useRecoilValue(USE_X_PATH);
}
